import format from '../utils/format';

export default {
	install(Vue, _options) {
		Vue.prototype.$format = format;
	}
};
